import { Outlet } from "react-router-dom";
import { BottomNav } from "./BottomNav";

export function Layout() {
  return (
    <div className="min-h-screen bg-background grain">
      <div className="max-w-md mx-auto min-h-screen pb-28 relative">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
